export default __webpack_public_path__ + "static/media/dssmith.dfe7a734.png";